<template>
  <div class="home">
    <nav-bar/>
    <div class="grid-container">
      <div class="large-header">
        <p>Latih kemampuan <i>computational thinking</i>-mu<br> dengan cara yang menyenangkan!</p>
      </div>
      <div class="guide-header">
        <h1>Ada apa saja di sini?</h1>
        <p>Tautan di bawah ini dapat membawamu langsung beraksi!</p>
      </div>
      <div class="guide-blocks flex-responsive">
        <div class="guide-block style-1">
          <i class="floating fas fa-chalkboard"/>
          <h2>Lessons</h2>
          <p>Sebuah pembelajaran komprehensif bertahap. Awali langkahmu di sini.</p>
          <router-link :to="{ name: 'lessons' }" class="guide-link">
            <span class="purple-gradient-text">Lihat</span> <i class="fas fa-chevron-right"/>
          </router-link>
        </div>
        <div class="guide-block style-2">
          <i class="floating fas fa-stream"/>
          <h2>Tasklist</h2>
          <p>Lihat daftar persoalan yang dapat kamu akses dan selesaikan!</p>
          <router-link :to="{ name: 'listings' }" class="guide-link">
            <span class="blue-gradient-text">Lihat</span> <i class="fas fa-chevron-right"/>
          </router-link>
        </div>
        <div class="guide-block style-3">
          <i class="floating fas fa-cubes"/>
          <h2>Sandbox</h2>
          <p>Kamu bisa berkreasi dan bereksperimen membuat apapun di sini.</p>
          <router-link :to="{ name: 'sandbox' }" class="guide-link">
            <span class="green-gradient-text">Menuju Sandbox</span> <i class="fas fa-chevron-right"/>
          </router-link>
        </div>
      </div>
      <div class="guide-header">
        <h1>Apa itu Blocode?</h1>
        <p>Blocode adalah sebuah portal berlatih untuk mengasah kemampuan <i>computational thinking</i>.</p>
        <div class="blank-area"></div>
      </div>
    </div>
    <footer-bar/>
  </div>
</template>

<script>
  import NavBar from '@/components/NavBar'
  import FooterBar from '@/components/FooterBar'

  export default {
    name: 'home',
    components: {
      NavBar,
      FooterBar,
    },
  }
</script>

<style lang="scss" scoped>
  @import "src/styles/colors";

  .large-header {
    font-weight: 300;
    font-size: 2.5rem;
    text-align: center;
    margin: 5rem 0;

    i {
      color: $blue;
      background: linear-gradient(to bottom right, #0C728B, $blue);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .guide-blocks {
    display: flex;
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .guide-block {
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    color: white;
    flex: 1;
    margin: 0 1rem 1rem;
    padding: 1.5rem;
    box-shadow: 0 10px 10px 0 rgba(black, 0.2);
    z-index: 0;

    &.style-1 {
      background-image: linear-gradient(to bottom right, #6f5da8, #1F2041);
    }

    &.style-2 {
      background-image: linear-gradient(to bottom right, #296f99, #314380);
    }

    &.style-3 {
      background-image: linear-gradient(to bottom right, #116e76, #001011);
    }

    i.floating {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 10rem;
      z-index: -1;
      color: rgba(white, 0.4);
      mix-blend-mode: overlay;
      transform: rotate(-15deg);
    }

    h2, p, a {
      z-index: 1;
    }
  }


  .blue-gradient-text {
    background: linear-gradient(to bottom right, #296f99, #333780);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    & + i {
      color: $blue;
    }
  }

  .purple-gradient-text {
    background: linear-gradient(to bottom right, #6f5da8, #1F2041);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    & + i {
      color: #1F2041;
    }
  }

  .green-gradient-text {
    background: linear-gradient(to bottom right, #116e76, #001011);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    & + i {
      color: #001011;
    }
  }

  .guide-header {
    h1 {
      color: $blue;
      background: linear-gradient(to bottom right, #0C728B, $blue);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .guide-link {
    font-weight: 700;
    margin-top: 1rem;
    background-color: white;
    padding: 0.25rem 0.75rem;
    border-radius: 10px;
    display: inline-block;
    float: right;
    box-shadow: 0 5px 0 0 gray;
    transition: all 0.3s cubic-bezier(.16,1.84,.68,.93), height 0s;

    &::before {
      content: "";
      user-select: none;
      display: block;
      margin-left: -0.75rem;
      margin-right: -0.75rem;
    }

    &:hover {
      transform: translateY(1px);
      box-shadow: 0 4px 0 0 gray;

      &::before {
        height: calc(0.5rem + 1px);
        margin-top: calc(-0.5rem - 1px);
      }
    }

    &:active {
      transform: translateY(5px);
      box-shadow: 0 0 0 0 gray;

      &::before {
        height: calc(0.5rem + 5px);
        margin-top: calc(-0.5rem - 5px);
      }
    }
  }

  .blank-area {
    margin: 0.5rem;
    height: 300px;
    text-align: center;
    background-color: rgba(black, 0.025);
    padding: 1rem;
    box-sizing: border-box;
    border-radius: 10px;
  }

  .dark-mode {
    .guide-header, .large-header i {
      filter: brightness(2) contrast(0.75);
    }
  }
</style>
